<script setup>
import { l } from '@utils/toolbox';
</script>
<template>
  <div class="empty-state">
    <div class="empty-icon">
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    </div>
    <h3>{{ l('chat.emptyState.title') }}</h3>
    <p>{{ l('chat.emptyState.description') }}</p>
  </div>
</template>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: $neutral-secondary-font-color;
  margin-top: auto;
}

.empty-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, $color-blue-200 0%, $color-blue-100 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: $main-btn-bg;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: $neutral-main-font-color;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
  color: $disabled-font-color;
}

</style>
